export type YmQueueFunction = {
  (...args: unknown[]): void;
  a?: unknown[][];
  l?: number;
};

declare global {
  var ym: YmQueueFunction | undefined;
  var dataLayer: unknown[] | undefined;
  var _tmr: Record<string, unknown>[] | undefined;
}

const ID = import.meta.env.VITE_YANDEX_METRIKA_ID
  ? Number(import.meta.env.VITE_YANDEX_METRIKA_ID)
  : undefined;

const ym = (...args: unknown[]) => (ID ? globalThis.ym?.(ID, ...args) : undefined);

export const ymHit = (url: string, options?: object) => ym('hit', url, options);

export const ymGoal = (goal: string, params?: object, callback?: () => void) =>
  ym('reachGoal', goal, params, callback);

export const ymParams = (params: object) => ym('params', params);

export function getYmClientId(): string | undefined {
  try {
    const match = globalThis.document?.cookie?.match(/(?:^|; )_ym_uid=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : undefined;
  } catch {
    return undefined;
  }
}

export function ymPurchase(purchase: object) {
  if (typeof globalThis.ym !== 'function') {
    return;
  }

  globalThis.dataLayer = globalThis.dataLayer || [];
  globalThis.dataLayer.push({ ecommerce: { currencyCode: 'RUB', purchase } });
}

export function funnelCtx() {
  const params = new URLSearchParams(globalThis.location.search);

  let ages: number[] = [];
  try {
    ages = JSON.parse(params.get('childAges') || '[]');
  } catch {
    /* noop */
  }

  const from = params.get('arrivalDate') ?? params.get('dateFrom') ?? undefined;
  const to = params.get('departureDate') ?? params.get('dateTo') ?? undefined;

  return {
    city: (params.get('cityName') || '').trim(),
    region: (params.get('regionName') || '').trim(),
    adults: Number(params.get('adults')) || 0,
    children: ages.length,
    child_ages: ages.join(','),
    has_children: ages.length > 0 ? 'yes' : 'no',
    nights:
      from && to ? Math.round((+new Date(to) - +new Date(from)) / 86_400_000) : null,
    booking_type: params.get('bookingType') ?? undefined,
  };
}
